import { createFileRoute } from '@tanstack/react-router';
import { CreateTicketPage } from '@/features/it-service/pages';

export const Route = createFileRoute('/it-service/incidents/new')({
  component: () => <CreateTicketPage ticketType="incident" />,
});
